import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Constants from "../../../Action/Constants";
import TextField from "../../Partials/Material/TextField";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { isInputEmpty } from "../../../Helpers/FormErrorhandler";

export class CoachNewAgency extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachNewAgency: false,
    hasModifiedData: false,
    errorFields: null,
    isSaving: false,
    //agency data
    name: this.getAgency()?.name,
    phone: "",
    companyRegistry: "",
    vat: "",
    website: "",
    mainBankAccountId: "",
    mainBankAccountName: "",
    bankAccountId: "",
    attachments: this.getAgency()?.attachments,
    agency: null,
    shortName: this.getAgency()?.shortName,
    email: "",
    address: {
      formattedAddress: ""
    },

    //Frontend errors
    phoneError: false,
    websiteError: false,
    emailError: false,
    addressError: false,
    mainBankAccountIdError: false,
    mainBankAccountNameError: false
    };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openCoachNewAgency: this.props.openCoachNewAgency,
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openCoachNewAgency: nextProps.openCoachNewAgency
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachNewAgency: false,
      hasModifiedData: false,
      errorFields: null,
      isSaving: false,
      //agency data
      name: this.getAgency()?.name,
      phone: "",
      companyRegistry: "",
      vat: "",
      website: "",
      mainBankAccountId: "",
      mainBankAccountName: "",
      bankAccountId: "",
      attachments: [],
      agency: null,
      shortName: "",
      email: "",
      address: {
        formattedAddress: ""
      },

      //Frontend errors
      phoneError: false,
      websiteError: false,
      emailError: false,
      addressError: false,
      mainBankAccountIdError: false,
      mainBankAccountNameError: false
    });
  }

  public onCloseCoachNewAgency = () => {
    this.openDialogNewPropertyFirstUser();
    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);
  }

  /* Logic for open other coaches */
  public openDialogNewPropertyFirstUser = () => {
    if (typeof this.props.openDialogNewPropertyFirstUser === "function") {
      this.props.openDialogNewPropertyFirstUser.call(this);
    }
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if(activeStep === 1 && (this.state.phone === "" || this.state.website === "" || this.state.email === "" || this.state.address?.formattedAddress === "")){
      return this.setState({
        phoneError: this.state.phone === "",
        websiteError: this.state.website === "",
        emailError: this.state.email === "",
        addressError: this.state.address?.formattedAddress === ""
      })
    }


    if(activeStep === 2 && (this.state.mainBankAccountName === "" || this.state.mainBankAccountId === "")){
      return this.setState({
        mainBankAccountNameError: this.state.mainBankAccountName === "",
        mainBankAccountIdError: this.state.mainBankAccountId === ""
      })
    }

    if (activeStep === steps.length - 1) { // it is last step
      this.onCloseCoachNewAgency();
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.startStepSecond();
        case 2:
          return this.startStepThird();
        case 3:
          return this.startStepFourth();
        case 4:
          return this.plusOneStep();
      }
    }
  };

  // public isInputEmpty = (inputName, inputValue) => {
  //   let newStateObj: any = {[inputName]: inputValue};
  //   newStateObj[`${inputName}Error`] = !inputValue.length;

  //   return newStateObj;
  // }

  public handleInputChange = (e) => {
    const { target: { name, value } } = e;
    const newState = isInputEmpty(name, value);

    this.setState(newState);
  }

  public handleAddressSelectorChange = ({formattedAddress}) => {
    this.setState({
      address: {
        formattedAddress,
      },
      addressError: !formattedAddress.length
    })
  }

  public handleBack = () => {
    const { activeStep } = this.state;
    this.clearFieldsError();

    return this.setState({
      activeStep: activeStep - 1,
    });
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("coach/newagency-step/first-title"), this.trans("coach/newagency-step/second-title"), this.trans("coach/newagency-step/third-title"), this.trans("coach/newagency-step/fourth-title"), this.trans("coach/newagency-step/fifth-title")];
  }

  public save = (): void => {
    this.saving(() => { 
      this.setState({
        phoneError: false,
        websiteError: false,
        emailError: false,
        addressError: false,
        mainBankAccountNameError: false,
        mainBankAccountIdError: false
      })

      return this.props.dispatch({
        type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_START,
        payload: {
          id: this.getAgency()?.id,
          agency: {
            name: this.state.name,
            shortName: this.state.shortName,
            email: this.state.email,
            phone: this.state.phone,
            address: { ...this.state.address },
            // mainBankAccountId: this.state.mainBankAccountId,
            // mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName
            },
            note: "",
            bic: "",
            companyRegistry: this.state.companyRegistry,
            vat: this.state.vat,
            website: this.state.website,
            generalContactId: this.getAgency()?.generalContactId,
            bankAccountId: this.state.bankAccountId
          }
        },
        onSuccess: (agency) => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR
          });

          this.props.dispatch({
            type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START,
            payload: {
              preferences: {
                launchPanelState: this.props.app?.settings?.user?.launchPanelState,
                userId: this.props.app?.session?.user?.id,
                hideSnackbar: true,
                finishWelcomeCoach: true
              }
            }
          });

          this.setState({
            isSaving: false,
            agency: agency,
            errorFields: []
          });

          this.plusOneStep();
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields
          });

          this.plusOneStep();
        }
      });
    });
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      case 4:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
        {step === 4 && this.fifthStepDetails()}
      </div>
    )
  }


  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div>        
        <div className="main-text-of-step center">
          {this.trans("coach/newagency-step/first-maintitletext", {agencyName: this.getAgency()?.name})}
        </div>
        <div className="info-text-gray" style={{marginTop: 0}}>
          {this.trans("coach/newagency-step/first-info1", {agencyName: this.getAgency()?.name})}
        </div>
        <div className="info-text-gray" style={{marginTop: 0}}>
          {this.trans("coach/newagency-step/first-info2", {agencyName: this.getAgency()?.name})}
        </div>
      </div>
    )
  }

  public secondStepDetails = () => {
    return (
      <div>
        <div className="main-text-of-step center">
          {this.trans("coach/newagency-step/second-maintitletext")}
        </div>
        <div className="info-text-gray center">
          {this.trans("coach/newagency-step/second-info1")}
        </div>
        <div className="fields-wrapper">
          <div className="fields-inner-wrapper">
            <TextField
              autoComplete="off"
                className="form-element full-size scroll-to-email"
                type="text"
                name="email"
                label={this.trans("general-agency-label-email")}
                value={this.state.email}
                onChange={this.handleInputChange}
                variant="standard"
                error={!!this.getErrorFor("email") || this.state.emailError}
              />
            {!!this.getErrorFor("email") ? <div className="component-error-text">{this.getErrorFor("email")}</div> : this.state.emailError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

            <TextField
              autoComplete="off"
              className="form-element full-size scroll-to-phone"
              type="text"
              name="phone"
              label={this.trans("agency-phone")}
              value={this.state.phone}
              onChange={this.handleInputChange}
              variant="standard"
              error={!!this.getErrorFor("phone") || this.state.phoneError}
            />
            {!!this.getErrorFor("phone") ? <div className="component-error-text">{this.getErrorFor("phone")}</div> : this.state.phoneError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

            <AddressSelector
              {...this.props}
              name="address.googlePlaceId"
              className="scroll-to-address"
              searchText={this.state.address?.formattedAddress}
              selectedAddress={this.state.address}
              onSelect={this.handleAddressSelectorChange}
              onClear={() => this.handleAddressSelectorChange({formattedAddress: ""})}
              styleInModal={"styleInModal"}
              required
              labelText={this.trans("agency-general-address")}
              error={this.state.addressError && this.trans("this-field-is-required")}
            />
            <div className="hint-styles-dialog">
              {this.trans("coach/newpropertyfirstuser-step/fifth-hintforaddress")}
            </div> 

            <TextField
              autoComplete="off"
              id="website"
              name="website"
              className="form-element full-size scroll-to-website"
              type="text"
              label={this.trans("label-website")}
              value={this.state.website}
              onChange={this.handleInputChange}
              variant="standard"
              error={!!this.getErrorFor("website") || this.state.websiteError}
            />
            {!!this.getErrorFor("website") ? <div className="component-error-text">{this.getErrorFor("website")}</div> : this.state.websiteError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

            <TextField
              autoComplete="off"
              id="companyRegistry"
              name="companyRegistry"
              className="form-element full-size scroll-to-companyRegistry"
              type="text"
              label={this.trans("label-company-registry") + this.trans("field/optional")}
              value={this.state.companyRegistry}
              onChange={this.handleInputChange}
              variant="standard"
              error={!!this.getErrorFor("companyRegistry")}
            />
            {!!this.getErrorFor("companyRegistry") && <div className="component-error-text">{this.getErrorFor("companyRegistry")}</div>}

            <TextField
              autoComplete="off"
              id="vat"
              name="vat"
              className="form-element full-size scroll-to-vat"
              type="text"
              label={this.trans("label-vat-number") + this.trans("field/optional")}
              value={this.state.vat}
              onChange={this.handleInputChange}
              variant="standard"
              error={!!this.getErrorFor("vat")}
            />
            {!!this.getErrorFor("vat") && <div className="component-error-text">{this.getErrorFor("vat")}</div>}
          </div>
        </div>
      </div>
    )
  }

  public thirdStepDetails = () => {
    return (
      <div>
        <div className="main-text-of-step center">
          {this.trans("coach/newagency-step/third-maintitletext")}
        </div>
        <div className="info-text-gray center">
          {this.trans("coach/newagency-step/third-info2")}
        </div>

        <div className="fields-wrapper">
          <div className="fields-inner-wrapper">
            <TextField
              autoComplete="off"
              className="form-element full-size scroll-to-mainBankAccountId"
              type="text"
              name="mainBankAccountId"
              label={this.trans("label-iban")}
              value={this.state.mainBankAccountId}
              onChange={this.handleInputChange}
              variant="standard"
              error={!!this.getErrorFor("mainBankAccountId") || this.state.mainBankAccountIdError}
            />
            {!!this.getErrorFor("mainBankAccountId") ? <div className="component-error-text">{this.getErrorFor("mainBankAccountId")}</div> : this.state.mainBankAccountIdError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
            <div className="hint-styles-dialog">
              {this.trans("coach/newpropertyfirstuser-step/fifth-hintforiban")}
            </div> 

            <TextField
              autoComplete="off"
              className="form-element full-size scroll-to-mainBankAccountName"
              type="text"
              name="mainBankAccountName"
              label={this.trans("label-bank-account-name")}
              value={this.state.mainBankAccountName}
              onChange={this.handleInputChange}
              variant="standard"
              error={!!this.getErrorFor("mainBankAccountName") || this.state.mainBankAccountNameError}
            />
            {!!this.getErrorFor("mainBankAccountName") ? <div className="component-error-text">{this.getErrorFor("mainBankAccountName")}</div> : this.state.mainBankAccountNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
          </div>
        </div>
      </div>
    );
  }

  public fourthStepDetails = () => {
    const filteredAttachments = this.state.attachments?.filter(attachment => attachment.isAvatar);

    return (
      <div>
        <div className="main-text-of-step center">
          {this.trans("coach/newagency-step/fourth-maintitletext")}
        </div>
        <div className="info-text-gray center">
          {this.trans("coach/newagency-step/fourth-info1")}
        </div>

        <div>
          {
            filteredAttachments?.length === 0 && (
              <div style={{display: "flex", justifyContent: "center"}}>
                <div className="container_logo">
                  <div className="container_watermark">
                      {this.trans("your-logo-here")}
                  </div>
                </div>
              </div>
            )
          }
          
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            amazonFolderName={this.getAgency()?.amazonFolderName}
            relation="agencyId"
            entity={this.getAgency()}
            attachments={filteredAttachments}
            onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            updateParentState={attachments => this.setState({attachments: attachments})}
            withoutBottomMargin={true}
            coachPresentation={true}
            doNotAllowAddAttachment={filteredAttachments?.length > 0}
            logoComponent={true}
            setNoChangeViewFlag={true}
          />

          <div className="info-text-gray center" style={{marginTop: "10px", textAlign: "center"}}>
            {this.trans("coach/newagency-step/fourth-hintlogo")}
          </div>
        </div>
      </div>
    );
  }

  public fifthStepDetails = () => {
    return (
      <div>
        {this.state.agency ?
          <div>
            <div style={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>{this.image.getAvatar("success", { size: 62 })}</div>
            <div className="main-text-of-step center">
              {this.trans("coach/newagency-step/fifth-maintitletext")}
            </div>
            <div className="info-text-gray">
              {this.trans("coach/newagency-step/fifth-info1", {agencyName: this.state.agency?.name})}
            </div>
            <div className="info-text-gray" style={{borderTop: "1px solid rgba(0, 0, 0, 0.1)", paddingTop: "25px", marginTop: "30px"}}>
              {this.trans("coach/newagency-step/fifth-info2")}
            </div>
          </div>
          :
          <div>
            <div className="main-text-of-step center">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="info-text-gray center">
              {this.trans("coach/newagency-step/fifth-info3")}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-welcome-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
            </div>
            <div className="info-text-gray center" style={{borderTop: "1px solid rgba(0, 0, 0, 0.1)", paddingTop: "25px", marginTop: "30px"}}>
              {this.trans("coach/newagency-step/fifth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  //Funcionality for steps
  public startStepFirst = () => {
    return this.agencyStartStepFirst();
  }

  public startStepSecond = () => {
    return this.agencyStartStepSecond();
  }

  public startStepThird = () => {
    return this.agencyStartStepThird();
  }

  public startStepFourth = () => {
    return this.agencyStartStepFourth();
  }

  //Methods for step logic
  public agencyStartStepFirst = () => {
    this.plusOneStep();
  }

  public agencyStartStepSecond = () => {
    this.plusOneStep();
  }

  public agencyStartStepThird = () => {
    this.plusOneStep();
  }

  public agencyStartStepFourth = () => {
    this.save();
  }

  //Methods
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }


  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    let errorFieldsLength;

    if(this.state.errorFields) {
      errorFieldsLength = this.state.errorFields.length
    }

    return (
      <React.Fragment>
        { activeStep !== steps.length &&
          <div style={{position: "relative", alignItems: "center", borderBottom: "1px solid rgba(0, 0, 0, 0.1)", marginBottom: "30px"}}>
            <div className="logo" style={{position: "absolute", top: "25px", left: "20px"}}>{"Casadesk"}</div>
            <Stepper activeStep={activeStep} className="step-header">
              {steps.map((label) => {
                const props = {};
                const labelProps = {};
                return (
                  <Step className="step" key={label} {...props}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
        }

      <div className="step-content-wrapper step-scrollable-content" style={{width: "460px"}}>
        {this.getStepContent(activeStep)}
      </div>

      { activeStep !== steps.length &&
        <div className={`button-container step-footer ${activeStep === steps.length - 1 ? "without-cancel" : ""}`}>
          <div style={{paddingRight: "7px"}}>
          { errorFieldsLength !== 0 && activeStep !== 0 && 
            <Button
              color="primary"
              variant="outlined"
              onClick={this.handleBack}
              className="back-button"
            >
              {this.trans("dialog-button/back")}
            </Button>
            }

            {(!errorFieldsLength || ( activeStep !== steps.length - 1 && errorFieldsLength)) &&
              <Button
                variant="contained"
                color="primary"
                onClick={activeStep === steps.length - 1 && errorFieldsLength ? this.onCloseCoachNewAgency : this.handleNext }
              >
                {activeStep === steps.length - 1 ? errorFieldsLength ? this.trans("dialog-button/close") : this.trans("dialog-button/newrealestate") : this.trans("coach/propertyowner-button/next")}
              </Button>
            }
          </div>
        </div>
      }
    </React.Fragment>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-assistant coach-full-screen-presentation has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.openCoachNewAgency}
          onClose={this.onCloseCoachNewAgency}
          disableBackdropClick={true}
          fullScreen
        >
          {this.renderContent()}
        </Dialog>

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
